import JobTriggerActivity from "components/Socials/JobTriggerActivity"
import JobTriggerPanel from "components/Socials/JobTriggerPanel"
import ProspectQueue from "components/Socials/ProspectQueue"

import type { ComponentProps } from "."
import { Wrapper } from "./styled"

const Prospects = ({
  discoveryIngest,
  followerSync,
  jobTriggerActivity,
  onRunDiscoveryIngest,
  onRunFollowerSync,
  prospectDefaults,
  ...queueProps
}: ComponentProps) => (
  <Wrapper>
    <JobTriggerPanel
      discoveryIngest={discoveryIngest}
      followerSync={followerSync}
      onRunDiscoveryIngest={onRunDiscoveryIngest}
      onRunFollowerSync={onRunFollowerSync}
      prospectDefaults={prospectDefaults}
    />

    <JobTriggerActivity activity={jobTriggerActivity} />

    <ProspectQueue {...queueProps} />
  </Wrapper>
)

export default Prospects
